// import { Events } from 'ionic-angular';
export class globalVariable{

static priviledeList: any;
  static tenatList: any;
  static publickey: any;
  static role_name : any;
  static user_uuid :any;
  static user_id :any;
  static role_id :any;
  static user_name :any;
  static jwttoken :any;
  constructor() {
    globalVariable.role_name = globalVariable.role_name;
    globalVariable.tenatList = globalVariable.tenatList;
    globalVariable.priviledeList = globalVariable.priviledeList;
    globalVariable.publickey = globalVariable.publickey;
    globalVariable.user_uuid = globalVariable.user_uuid;
    globalVariable.user_id = globalVariable.user_id;
    globalVariable.role_id = globalVariable.role_id;
    globalVariable.user_name = globalVariable.user_name;
    globalVariable.jwttoken = globalVariable.jwttoken;
 }
}



export class changeValue {
  constructor() {}
  changePriviledgeId(priviledeList:any){
    globalVariable.priviledeList = priviledeList;
  }
  changeTenatId(tenatList:any){
    globalVariable.tenatList = tenatList;
  }
}
